module.exports = __webpack_public_path__ + "img/tab7.4c58eb99.png";